React = require 'react'
JoinRequestComponent = require 'views/enterprise/dashboard/join-request-component'
TeamItemComponent = require 'views/enterprise/dashboard/team-item-component'
t = require('views/internal/recup-with-helpers')('team_list_component')

module.exports = class extends React.Component
  render: t.renderable ->
    {
      items,
      onPopoverClick,
      onDecline,
      onAccept,
      onViewUntransferredMembers,
      onViewNewBillableMembers
      joinRequests,
      attemptedToLoadUserTypes,
      availableLicenses
    } = @props

    t.ul =>
      if !attemptedToLoadUserTypes
        t.div '.join-request', ->
          t.div '.spinner'
      else
        joinRequests.forEach (joinRequest) ->
          t.li =>
            t.addElement React.createElement JoinRequestComponent, {
              joinRequest
              onDecline
              onAccept
              onViewUntransferredMembers
              onViewNewBillableMembers
              availableLicenses
            }

      items.forEach (item) ->
        t.li =>
          t.addElement React.createElement TeamItemComponent, {
            item
            eventHandlers: { onPopoverClick }
          }



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/team-list-component.coffee